<template>
  <v-banner class="premium-banner" color="secondary" app min-height="64px"
    ><div class="d-flex justify-center">
      <p class="subtitle-1 my-auto">
        {{ $t("premium.banner.text") }}
      </p>
      <niko-button
        @onClick="openFastSpringPopup"
        class="ml-6"
        primary
        :text="$t('premium.banner.button')"
      /></div
  ></v-banner>
</template>

<script>
import NikoButton from "@/components/UI/NikoButton";
import { mapState } from "vuex";

export default {
  name: "niko-premium-banner",
  components: {
    NikoButton,
  },
  computed: {
    ...mapState("authStore", ["email, firstname", "lastname"]),
  },
  methods: {
    openFastSpringPopup() {
      window.fastspring.builder.recognize({
        email: this.email,
        firstName: this.firstname,
        lastName: this.lastname,
      });
      window.fastspring.builder.add("fa-assistent-premium");
      window.fastspring.builder.checkout();
    },
  },
};
</script>

<style lang="scss">
.premium-banner {
  .v-banner__wrapper {
    padding: 12px 0px !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.4) !important;
    .v-banner__text {
      width: -webkit-fill-available;
    }
  }
}
</style>
